import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialKlarnaReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const klarnaSlice = createSlice({
    name: "Klarna",
    initialState: { ...initialKlarnaReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default klarnaSlice;
